import { useEditablePage } from '@/hooks/useEditablePage';
import EditableText from '@/components/pageEditor/EditableText';
import RichText from '@/components/pageEditor/RichText';
import EditBar from '@/components/pageEditor/EditBar';
import PageState from '@/components/pageEditor/PageState';

const About = () => {
  const page = useEditablePage('about');
  const { data, editing, update } = page;

  if (!data) return <PageState page={page} />;

  return (
    <div className="py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-[1200px]">
        <EditableText
          as="h1"
          editing={editing}
          value={data.title}
          onChange={(v) => update(['title'], v)}
          placeholder="عنوان الصفحة"
          className="block text-4xl md:text-5xl font-tajawal font-bold text-center mb-8"
        />
        <RichText
          editing={editing}
          html={data.content?.body}
          onChange={(v) => update(['content', 'body'], v)}
          placeholder="اكتبي عن المتجر..."
          className="max-w-[65ch] mx-auto font-cairo text-lg leading-relaxed [&>p:first-child]:text-xl"
        />
      </div>
      <EditBar page={page} />
    </div>
  );
};

export default About;
